import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initGA, trackPageView } from "../../../utils/analytics";

const GA_ID = "G-W07YKRLB5N";

export default function GoogleAnalyticsTracker(): null {
  const location = useLocation();

  useEffect(() => {
    if (process.env.NODE_ENV === "production") {
      initGA(GA_ID);
    }
  }, []);

  useEffect(() => {
    if (process.env.NODE_ENV === "production") {
      trackPageView(GA_ID, location.pathname + location.search);
    }
  }, [location]);

  return null;
}
